import BackButton from "components/Common/BackButton"

const AccessDenied = () => {
  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center text-center bg-light">
      <div className="mb-4">
        {/* Font Awesome classic icon */}
        <i className="fas fa-lock fa-6x text-warning mb-3"></i>
        <h1 className="display-1 fw-bold text-dark">401</h1>
      </div>
      <h2 className="fs-3 fw-semibold text-secondary mb-3">
        Oops! Access Denied
      </h2>
      <p className="text-muted mb-4">
        You don’t have permission to view this page.
      </p>
      <BackButton />
    </div>
  )
}

export default AccessDenied
